import {
    calcPercentFromSum
} from '@/helpers/lot-helpers';
import downloadFile from '@/helpers/download-file';

export default {
    state: {
        data: {},
        lotDocuments: [],
        canUpdate: false,
        canCreateRequest: null,
        cantCreateRequestDescription: null,
        lotRequests: [],
        lotRequestLogs: [],
        lotRequestPriceOffer: null,
        userLotRequest: {},
        lotRequestFiles: [],
        loading: false,
        error: false,
        saveError: false,
        success: false,
        loadingRequests: false,
        requestActionStatus: null,
        hallSignes: {},
        userLotParticipate: false,
        socketAvailable: false,
        socketOnceConnected: false,
    },
    mutations: {
        setLotRequests: (state, value) => (state.lotRequests = [...value]),
        setLotRequestLogs: (state, value) => (state.lotRequestLogs = [...value]),
        setUserLotRequest: (state, value) => (state.userLotRequest = value),
        setUserLotParticipate: (state, value) => (state.userLotParticipate = value),
        setLotRequestFiles: (state, value) => (state.lotRequestFiles = [...value]),
        setLotRequestPriceOffer: (state, value) => (state.lotRequestPriceOffer = value),
        setData: (state, value) => {
            if (Number(value['percent_deposit_price']) === 1) {
                value['deposit_price'] = calcPercentFromSum(value['start_price'], value['deposit_price'])
            }
            if (Number(value['percent_step']) === 1) {
                value['step'] = calcPercentFromSum(value['start_price'], value['step'])
            }
            state.data = {...value}
        },
        setLotDocuments: (state, value) => (state.lotDocuments = value),
        setError: (state, value) => (state.error = value),
        setSaveError: (state, value) => (state.saveError = value),
        setSuccess: (state, value) => (state.success = value),
        removeError: state => (state.error = false),
        loadingProcess: state => (state.loading = true),
        loadingCompleted: state => (state.loading = false),
        loadingRequests: (state, value = true) => (state.loadingRequests = value),
        updateData: (state, value) => {
            for(const key in value) {
                if(value.hasOwnProperty(key)) {
                    state.data[key] = value[key]
                }
            }
        },
        setStatus: (state, value) => (state.data.status = value),
        setRequestActionStatus: (state, value) => (state.requestActionStatus = value),
        setCanUpdate: (state, value) => (state.canUpdate = value ?? false),
        setSocketStatus: (state, value) => (state.socketAvailable = value),
        socketOnceConnected: (state) => (state.socketOnceConnected = true),
        setHallSign: (state, {lotId, sign}) => (state.hallSignes[lotId] = sign),
        setCanCreateRequest: (state, value) => (state.canCreateRequest = value),
        setCantCreateRequestDescription: (state, value) =>
            (state.cantCreateRequestDescription = value),
        setRawData: (state, data) => {
            state.data = {...data}
        },
    },
    actions: {
        fetchLot: ({commit, dispatch}, id) => {
            commit("removeError");
            commit("loadingProcess");
            commit("setData", {
                id
            });

            return dispatch('fetchLotInternal', id)
            .finally(() => commit("loadingCompleted"));
        },

        fetchRequests: ({commit, state, dispatch}) => {
            commit("loadingRequests");
            const id = state.data.id
            return dispatch('fetchLotInternal', id)
            .finally(() => commit("loadingRequests", false));
        },

        updateLotInfo: ({commit, dispatch, state}, data) => {
            commit("updateData", data)
        },

        downloadLotDocumentFile: ({ commit, state }, doc) => {
            const url = `/api/lots/${state.data.id}/documents/${doc.id}`;
            downloadFile(url, null);
        },

        deleteLotDocumentFile: ({commit, state}, doc) => {
            const url = `/admin/lots/${state.data.id}/documents/${doc.id}`;

            axios.delete(url)
                .then(res => {
                    if (res.data) {
                        commit("setLotDocuments", res.data.data ?? []);
                        commit("removeError");
                    }
                }).catch(err => {
                commit("setError", "Неизвестная ошибка");
            });
        },
    }
};
